<template>
  <div class="mobile-repair-form">
    <a-form ref="formRef" :model="formState" :rules="rules">
      <a-form-item label="年度" name="year">
        <a-input v-model:value="formState.year" placeholder="年度" allowClear></a-input>
      </a-form-item>

      <a-form-item label="生产日期" name="produceDate">
        <a-date-picker v-model:value="formState.produceDate"
          @change="(e, stringTime) => formState.produceDate = stringTime" placeholder="生产日期" allowClear></a-date-picker>
      </a-form-item>

      <a-form-item label="机身号类型" name="model">
        <series-type-cascader type="machineOptions" placeholder="请选择机身号类型" :source="formState" ref="seriesTypeRef"
          :target="['serialType', 'model']"></series-type-cascader>
      </a-form-item>

      <a-form-item label="机身号" name="serial">
        <a-input v-model:value="formState.serial" placeholder="请输入机身号" allowClear></a-input>
      </a-form-item>

      <a-form-item label="问题现象" name="problemPhenomenon">
        <after-sale-qeustion-vue :questionLists="formState.problemPhenomenon"
          ref="questionRef"></after-sale-qeustion-vue>
      </a-form-item>

      <a-form-item label="状态" name="status">
        <a-select v-model:value="formState.status" :options="afterSaleOptions" allowClear
          @change="handleAfterSaleMaintenance" placeholder="请选择状态"
          :disabled="formState.status === '已完成' || formState.status === '问题分析'">
        </a-select>
      </a-form-item>

      <a-form-item label="临时措施" name="temporaryMeasures" v-if="formState.status === '现场维修'">
        <a-textarea v-model:value="formState.temporaryMeasures" :auto-size="{ minRows: 1, maxRows: 10 }"
          placeholder="临时措施" allowClear></a-textarea>
      </a-form-item>

      <a-form-item label="售后问题图片">
        <upload-img-vue :attachment="formState.picture" ref="uploadImg"></upload-img-vue>
      </a-form-item>
      <a-form-item label="售后问题视频">
        <upload-video-vue :attachment="formState.video" ref="uploadVideo"></upload-video-vue>
      </a-form-item>
    </a-form>

    <a-space>
      <a-button @click="backPre">返回</a-button>
      <a-button @click="handleOk" type="primary">提交表单</a-button>
    </a-space>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  ref,
  nextTick,
  onDeactivated,
  onActivated
} from "vue";
import { useStore } from "vuex";
import { Toast, uploadMedia, timeStampToTime } from "@/utils/index";
import {
  insertAfterSaleRepair,
  updateAfterSaleRepair,
} from "@/request/view/afterSaleRepair";
import { questionTypeOptions, afterSaleOptions } from '@/views/afterSaleRepair/pc/data';
import websocket from "@/utils/base/socket";
import { getEngineeringDepartment } from '@/utils/base/staff.js';
import uploadImgVue from "@/views/repairprogress/compoments/uploadImg.vue";
import uploadVideoVue from "@/views/repairprogress/compoments/uploadVideo.vue";
import accessoryVue from "@/views/repair/components/accessory.vue";
import afterSaleQeustionVue from "@/views/repair/components/afterSaleQeustion.vue";
import seriesTypeCascader from '@/components/cascader/index.vue';
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  components: {
    uploadImgVue,
    uploadVideoVue,
    accessoryVue,
    seriesTypeCascader,
    afterSaleQeustionVue,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();
    const user = store.state.user.user;
    const selectSerial = ref([]);
    const seriesTypeRef = ref();
    // 返修表单
    const formState = reactive({
      analysisDept: null,
      closedLoopMeasures: null,
      confirmationAndAnalysis: null,
      createUserId: null,
      executionDept: null,
      feedbackDate: null,
      feedbackDept: null,
      recipient: null,
      id: null,
      model: null,
      implementationMeasures: null,
      notes: null, picture: null,
      problemPhenomenon: null,
      problemType: null,
      produceDate: null,
      rootCauseAnalysis: null,
      serial: null,
      serialType: null,
      status: null,
      supervisionDept: null,
      temporaryMeasures: null,
      video: null,
      year: null
    });

    const formRef = ref();

    const accessoryRef = ref();
    const accessoryList = reactive([]);
    const uploadImg = ref();

    const uploadVideo = ref();

    const questionRef = ref();

    const getAfterSaleProblemDescription = () => {
      return questionRef.value.questionList.reduce((a, b) => a + `${b.value}#`, '').replace(/(.*)#/, '$1');
    };

    const validateProblemPhenomenon = async (rule, value) => {
      const problemDescription = getAfterSaleProblemDescription().replace(/#/g, '');
      if (problemDescription === '') {
        return Promise.reject(rule.message);
      }
      return Promise.resolve();
    };

    const rules = {
      analysisDept: [{ required: true, message: '请输入分析部门', trigger: 'change' }],
      closedLoopMeasures: [{ required: true, message: '请输入闭环措施', trigger: 'change' }],
      confirmationAndAnalysis: [{ required: true, message: '请输入情况分析', trigger: 'change' }],
      executionDept: [{ required: true, message: '请输入执行部门', trigger: 'change' }],
      implementationMeasures: [{ required: true, message: '请输入执行措施', trigger: 'change' }],
      problemPhenomenon: [{ required: true, message: '请输入问题现象', validator: validateProblemPhenomenon, trigger: 'change' }],
      problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }],
      produceDate: [{ required: true, message: '请选择生产日期', trigger: 'change' }],
      rootCauseAnalysis: [{ required: true, message: '请输入根本原因分析', trigger: 'change' }],
      serial: [{ required: true, message: '请输入机身号', trigger: 'change' }],
      model: [{ required: true, message: '请选择设备型号', trigger: 'change' }],
      status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      supervisionDept: [{ required: true, message: '请输入监督部门', trigger: 'change' }],
      year: [{ required: true, message: '请输入年度', trigger: 'change' }]
    };

    const resetForm = () => {
      formRef.value.clearValidate();
      questionRef.value.resetList();
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
    };

    const backPre = () => {
      nextTick(() => {
        router.back();
      });
    };

    // websocket通知
    const websocketNotice = (toUserId, msg) => {
      if (user.id == toUserId) return Toast('发送人和通知人不能一致');

      return websocket.Send({
        content: msg,
        query: JSON.stringify({
          serial: formState.serial,
          activeKey: 'afterSaleRepair',
          type: "link",
        }),
        route: "/aftersalerepair",
        messageSort: '日常报修',
        toUserId,
        type: 0,
        userId: user.id,
      });
    };

    const handleOk = () => {
      // 售后问题
      const problemPhenomenon = getAfterSaleProblemDescription();

      const payload = Object.assign({}, formState);
      payload.problemPhenomenon = problemPhenomenon;

      formRef.value
        .validateFields()
        .then(async (res) => {
          // 上传文件
          if (uploadImg.value && uploadVideo.value) {
            await uploadMedia(uploadImg, uploadVideo).then((res) => {
              payload.picture = JSON.stringify(res[0]);
              payload.video = JSON.stringify(res[1]);
            });
          }

          let requestFn;

          switch (route.query.type) {
            case 'add':
              requestFn = insertAfterSaleRepair;
              localStorage.setItem("QC_QC_update", 1);
              const department = process.env.NODE_ENV === 'production' ? '试产中心' : '工程部';
              await getEngineeringDepartment(department).then((res) => {
                if (res) {
                  const { id, nickName } = res;
                  formState.recipient = `${nickName},${id.slice(1)}`;
                  websocketNotice(id.slice(1), `${user.nickName}推送 日常报修 请处理报修信息`);
                } else {
                  Toast('warning', '网络问题消息通知未发送', 3);
                }
              });
              break;
            default:
              requestFn = updateAfterSaleRepair;
              break;
          }

          requestFn(payload).then((res) => {
            const type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            backPre();
          });
        })
        .catch((err) => {
          console.log(err);
          if (err && err.errorFields) {
            const [errText] = err.errorFields[0].errors;
            Toast("warning", errText, 3);
          }
        });

    };

    const echoMobileForm = (data, type) => {
      Object.keys(formState).forEach((key) => {
        if (key === 'problemPhenomenon') {
          const list = [];
          data.problemPhenomenon.split('#').forEach((str) => {
            list.push({
              value: str,
              disabled: type === 'analysis',
            })
          });
          formState.problemPhenomenon = JSON.stringify(list)
          return;
        }
        formState[key] = data[key];
      });
    };

    // 售后人员维修
    const handleAfterSaleMaintenance = () => {

    };

    onDeactivated(() => {
      nextTick(() => {
        resetForm();
      });
    });

    onActivated(() => {
      if (route.query.type === "echo") {
        echoMobileForm(JSON.parse(route.query.data), route.query.type);
        seriesTypeRef.value.echoData()
      } else if (route.query.type === 'add') {
        seriesTypeRef.value.echoData();
        formState.feedbackDate = timeStampToTime('', 'seconds');
        formState.year = String(new Date().getFullYear());
        formState.createUserId = user.id;
        formState.feedbackDept = `${user.firstLevelDepartment}${user.nickName}`;
      }
    });

    return {
      formState,
      accessoryRef,
      uploadImg,
      uploadVideo,
      questionRef,
      rules,
      accessoryList,
      handleOk,
      seriesTypeRef,
      formRef,
      selectSerial,
      backPre,
      handleAfterSaleMaintenance,
      afterSaleOptions,
      questionTypeOptions,
    };
  },
});
</script>

<style lang="less" scoped>
.mobile-repair-form {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
  padding: 20px 20px;
}

.flex-wrap {
  flex-wrap: wrap;
}
</style>
